import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Input from 'src/components/Input';
import Select from 'react-select';
import File from 'src/components/File';
import FontAwesomeIcon from 'src/components/Icon';
import { variables } from 'src/Tenants';

interface StatusOption {
  value: string;
  label: string;
}

interface SuiteDetailsSectionProps {
  suiteFormData: any;
  statusOptions: StatusOption[];
  selectedStatus: StatusOption | null;
  isSparkDisabled: boolean;
  floorImage: any;
  floorplanFiles: any[];
  floorplanImage: any;
  floorplanError: any;
  showPdfFloorplanLink: boolean;
  isFloorplanStaged: boolean;
  stagedFloorplanName: string;
  onSetSuiteFormData: (data: any) => void;
  onSelectStatus: (option: any) => void;
  onValidateFile: (file: any) => void;
  onClearFloorplan: () => void;
}

const SuiteDetailsSection = ({
  suiteFormData,
  statusOptions,
  selectedStatus,
  isSparkDisabled,
  floorImage,
  floorplanFiles,
  floorplanImage,
  floorplanError,
  showPdfFloorplanLink,
  isFloorplanStaged,
  stagedFloorplanName,
  onSetSuiteFormData,
  onSelectStatus,
  onValidateFile,
  onClearFloorplan,
}: SuiteDetailsSectionProps) => {
  return (
    <>
      <h2>{`${variables.Suite} Details`}</h2>
      <Row>
        <Col xs="12" md="6">
          <Input
            value={suiteFormData.number ? suiteFormData.number : ''}
            onChange={(e: any) => onSetSuiteFormData({ number: e.target.value })}
            label={
              variables.Suite === 'Suite'
                ? variables.Suite + ' Number :'
                : variables.Suite + ''
            }
            placeholder={
              variables.Suite === 'Suite'
                ? variables.Suite + ' Number'
                : variables.Suite + ''
            }
            block
            required={true}
            disabled={isSparkDisabled}
          />
        </Col>
        <Col xs="12" md="6">
          <Input
            value={
              suiteFormData.warrantyAddress ? suiteFormData.warrantyAddress : ''
            }
            onChange={(e: any) =>
              onSetSuiteFormData({ warrantyAddress: e.target.value })
            }
            label="Warranty/Civic Address :"
            placeholder="Warranty/Civic Address"
            block
          />
        </Col>
      </Row>
      <Row>
        <Col xs="6" md="6">
          <div className="suite-form-field">
            <div className="suite-form-label-row">
              <div className="reporting__heading suite-form-label">Status</div>
              <div className="input__required" />
            </div>
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={onSelectStatus}
              placeholder="(Select status)"
              isDisabled={isSparkDisabled}
              isSearchable={false}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="12">
          <File
            label="Floorplan"
            description="Upload photos (JPG or PNG or PDF)."
            onSelect={(file: any) => onValidateFile(file)}
            files={floorplanFiles}
            image={floorplanImage}
            errors={floorplanError}
          />
          {showPdfFloorplanLink && (
            <a href={floorImage} target="_blank">
              {floorImage.split('.com/')[1]}
            </a>
          )}
          {isFloorplanStaged && (
            <div className="floorplan-staged">
              <label className="floorplan-staged-label">
                {stagedFloorplanName} — staged, not uploaded yet. Click Save to
                apply.
              </label>
              <span
                className="floorplan-staged-clear"
                onClick={onClearFloorplan}
                title="Remove floorplan"
              >
                <FontAwesomeIcon
                  glyph="times-circle"
                  weight="regular"
                  size="small"
                />
              </span>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SuiteDetailsSection;
